module.exports = __webpack_public_path__ + "static/media/header-checkerboard-booking.f8418aef.svg";